import { fetchPromo, generateFetchOpts } from 'api/editor';
import { POST, DELETE } from 'api/common';

/**
 * @method createPromoMissionRelation 建立 mgm relation
 * @param  {string} sponsorId
 * @param  {string} promoId
 * @param  {object} body api body ( 參考 https://app.clickup.com/t/860rtq7ek)
 * @return {promise}
 */
export function createPromoMissionRelation(sponsorId, promoId, body) {
    return fetchPromo(
        `/services/sponsors/${sponsorId}/promotions/${promoId}/mgm/relation`,
        generateFetchOpts({ method: POST, body })
    );
}

/**
 * @method deletePromoMissionRelation 建立 mgm relation
 * @param  {string} sponsorId
 * @param  {string} promoId
 * @param  {object} body api body ( 參考 https://app.clickup.com/t/860rtq7ek)
 * @return {promise}
 */
export function deletePromoMissionRelation(sponsorId, promoId) {
    return fetchPromo(
        `/services/sponsors/${sponsorId}/promotions/${promoId}/mgm/relation`,
        generateFetchOpts({ method: DELETE })
    );
}

/**
 * 取得 MGM 關聯的模組編號資料 api https://app.clickup.com/t/866apr624
 * @param   {string} sponsorId sponsorId
 * @param   {string} promId promoId
 * @return  {promise}
 */

export const getMgmRelationByEditorApi = ({ sponsorId, promoId }) => {
    return fetchPromo(
        `/services/sponsors/${sponsorId}/promotions/${promoId}/mgm/relation`,
        generateFetchOpts(),
        {
            strictErrThrow: false
        }
    );
};
